module.exports = __webpack_public_path__ + "static/img/payermax-icon.6ed94a80.png";